import { AdminTraining } from "../../core/admin/entities/AdminRole";
import { pb } from "../pocketbase/pocketbase";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapRecord(record: any): AdminTraining {
  return {
    id: record.id,
    adminId: record.adminId,
    trainingId: record.trainingId,
    role: record.role,
  };
}

export const adminTrainingRepository = {
  async getByAdminId(adminId: string): Promise<AdminTraining[]> {
    const records = await pb.collection("adminTrainings").getFullList({
      filter: `adminId = "${adminId}"`,
      requestKey: null,
    });
    return records.map(mapRecord);
  },
};
